"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _COLOUR_MAPPINGS;

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: ", ";\n  padding: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation: ", " ", " ", " ", "\n    ", " ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0%{\n    background-position: -", "px 0\n  }\n  100%{\n    background-position: ", "px 0\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// use constants
var DEFAULT = 'default';
var BLANK = 'blank';
var SHADE = 'on-shade';
var DARK = 'on-dark'; // animation constants

var DURATION = '1s';
var TIMING_FUNC = 'linear';
var DELAY = '0s';
var ITERATION = 'infinite';
var FILL_MODE = 'forwards';
var POSITION_X = 700;
var SHIMMER_ANIMATION = (0, _styledComponents.keyframes)(_templateObject(), POSITION_X, POSITION_X);
var COLOUR_MAPPINGS = (_COLOUR_MAPPINGS = {}, (0, _defineProperty2.default)(_COLOUR_MAPPINGS, DEFAULT, {
  primary: _colors.GYPSUM,
  secondary: _colors.KOALA
}), (0, _defineProperty2.default)(_COLOUR_MAPPINGS, SHADE, {
  primary: _colors.KOALA,
  secondary: _colors.GYPSUM
}), (0, _defineProperty2.default)(_COLOUR_MAPPINGS, DARK, {
  primary: _colors.HEFFALUMP,
  secondary: _colors.SLINKY
}), _COLOUR_MAPPINGS);
var BLANK_BACKGROUND = "\n  background: " + _colors.OLAF + ";\n";

var makeGradientBackground = function makeGradientBackground(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary;
  return "\n  background: " + primary + ";\n  background: linear-gradient(to right, " + primary + ", " + secondary + " 20%, " + primary + " 40%);\n  background-size: 1200px;\n";
};

var animation = (0, _styledComponents.css)(_templateObject2(), SHIMMER_ANIMATION, DURATION, TIMING_FUNC, DELAY, ITERATION, FILL_MODE);

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};

var getSize = function getSize(value) {
  return isNumber(value) ? value + "px" : value;
};

var getColourPattern = function getColourPattern(useOption) {
  return COLOUR_MAPPINGS[useOption];
};

var getBackground = function getBackground(_ref2) {
  var use = _ref2.use;
  return use === BLANK ? BLANK_BACKGROUND : makeGradientBackground(getColourPattern(use));
};

var SkeletonBase = _styledComponents.default.div.withConfig({
  displayName: "SkeletonBase",
  componentId: "emi2x-0"
})(_templateObject3(), function (_ref3) {
  var margin = _ref3.margin;
  return margin ? getSize(margin) : undefined;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding ? getSize(padding) : undefined;
}, function (_ref5) {
  var use = _ref5.use;
  return getBackground({
    use: use
  });
}, function (_ref6) {
  var use = _ref6.use;
  return use !== BLANK && animation;
});

SkeletonBase.defaultProps = {
  use: DEFAULT
};
SkeletonBase.propTypes = {
  margin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  use: _propTypes.default.oneOf([DEFAULT, SHADE, DARK, BLANK])
};
var _default = SkeletonBase;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/loading/SkeletonBase.js
// module id = 595
// module chunks = 5 6